import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../services/api'

// Estado EN/FUERA DE SERVICIO de la compañía (manual u automático). El endpoint
// /api/compania-servicio devuelve { enServicio, modo, manualEnServicio, motivo, detalle }.
export const fetchEstadoServicio = createAsyncThunk('companiaServicio/fetch', async (_, { rejectWithValue }) => {
  try { const r = await api.get('/compania-servicio'); return r.data }
  catch (e) { return rejectWithValue(e.response?.data?.mensaje || 'Error al obtener el estado de servicio') }
})

export const updateServicio = createAsyncThunk('companiaServicio/update', async (data, { rejectWithValue }) => {
  try { const r = await api.put('/compania-servicio', data); return r.data }
  catch (e) { return rejectWithValue(e.response?.data?.mensaje || 'Error al actualizar el estado de servicio') }
})

const slice = createSlice({
  name: 'companiaServicio',
  initialState: { estado: null, loading: false, saving: false, error: null },
  reducers: { clearError: (s) => { s.error = null } },
  extraReducers: (b) => {
    b.addCase(fetchEstadoServicio.pending, (s) => { s.loading = true; s.error = null })
      .addCase(fetchEstadoServicio.fulfilled, (s, a) => { s.loading = false; s.estado = a.payload })
      .addCase(fetchEstadoServicio.rejected, (s, a) => { s.loading = false; s.error = a.payload })
      .addCase(updateServicio.pending, (s) => { s.saving = true; s.error = null })
      .addCase(updateServicio.fulfilled, (s, a) => { s.saving = false; s.estado = a.payload })
      .addCase(updateServicio.rejected, (s, a) => { s.saving = false; s.error = a.payload })
  },
})

export const { clearError } = slice.actions
export default slice.reducer
